import { InvoicePosition } from "./invoice-position.model"


export class InvoicePositionGroup {
	name: string
	invoicePositions: InvoicePosition[]
	pos: number
}



// WEBPACK FOOTER //
// ./src/app/models/invoice-position-group.model.ts